export const DEFAULT_CODE_THEME = 'alan-default-theme';

export const codeThemes = [
    { title: 'Alan Default', id: DEFAULT_CODE_THEME },
    { title: 'Midnight Forest', id: 'midnight-forest-theme' },
    { title: 'Lavender', id: 'lavender-theme' },
    { title: 'Coffebreak', id: 'coffebreak-theme' },
    { title: 'Cardboard', id: 'cardboard-theme' },
    { title: 'Bayview', id: 'bayview-theme' }
];